// File: frontend/src/pages/AIAgents/components/AgentCounter.js

import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import styles from './AgentCounter.module.css';

const AgentCounter = ({ currentIndex, totalAgents }) => {
  return (
    <motion.div 
      className={styles.counter}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.3 }}
    >
      <span className={styles.current}>{currentIndex}</span>
      <span className={styles.separator}>/</span>
      <span className={styles.total}>{totalAgents}</span>
    </motion.div>
  );
};

AgentCounter.propTypes = {
  currentIndex: PropTypes.number.isRequired,
  totalAgents: PropTypes.number.isRequired
};

export default AgentCounter;